import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AuthGuard } from '@/components/auth/AuthGuard'
import {
  LoginPage,
  TendersPage,
  TenderDetailPage,
  CompaniesPage,
  CompanyDetailPage,
  AgenciesPage,
  AgencyDetailPage,
  TagsPage,
  WatchlistPage,
  ContractsPage,
  AwardsPage,
  BidsPage,
  AttachmentsPage,
  CrawlRunsPage,
  OcrPage,
  RfqPage,
} from '@/pages'

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <AuthGuard>
              <AppShell />
            </AuthGuard>
          }
        >
          {/* Default redirect */}
          <Route index element={<Navigate to="/tenders" replace />} />

          {/* Main pages */}
          <Route path="tenders" element={<TendersPage />} />
          <Route path="tenders/:id" element={<TenderDetailPage />} />
          <Route path="companies" element={<CompaniesPage />} />
          <Route path="companies/:id" element={<CompanyDetailPage />} />
          <Route path="agencies" element={<AgenciesPage />} />
          <Route path="agencies/:id" element={<AgencyDetailPage />} />
          <Route path="tags" element={<TagsPage />} />
          <Route path="tags/:id" element={<TagsPage />} />
          <Route path="watchlist" element={<WatchlistPage />} />

          {/* Pro operations */}
          <Route path="pro/contracts" element={<ContractsPage />} />
          <Route path="pro/contracts/:id" element={<ContractsPage />} />
          <Route path="pro/awards" element={<AwardsPage />} />
          <Route path="pro/bids" element={<BidsPage />} />
          <Route path="pro/attachments" element={<AttachmentsPage />} />
          <Route path="pro/crawl-runs" element={<CrawlRunsPage />} />
          <Route path="pro/ocr" element={<OcrPage />} />
          <Route path="pro/rfq" element={<RfqPage />} />
        </Route>

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
